import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './WpExchangeResult.module.less';
import SuccessImg from '../../static/wp/wp_result_suc.png';
import ErrImg from '../../static/wp/wp_result_err.png';
import { setWpResultShow, getVipState } from '../../actions/wallpaperPay';
import { logging } from '../../actions/log';
import Dialog from '../../components/Dialog/Dialog';

let resultObj = {
  '1': '您已成功兑换壁纸订阅服务',
  '2': '该兑换码已失效',
  '3': '该兑换码已被使用过',
  '4': '无效兑换码',
  '5': '兑换失败，请您稍后再试',
};

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectExchangeResult = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.exchangeResult,
);

export default memo(() => {
  const dispatch = useDispatch();
  const result = useSelector(selectExchangeResult);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    if (result?.resultCode) {
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'R_Wallpaper_Convert_Result',
          label: '',
          param2: {
            source: logInfoData?.source,
            source_p: logInfoData?.source_p,
            source_pp: logInfoData?.source_pp,
            msg: result?.resultCode,
            status: result?.resultCode === '1' ? 1 : 0,
          },
        }),
      );
    }

    if (result?.resultCode === '1') {
      dispatch(getVipState());
    }
  }, [result]);

  return (
    <Dialog
      title=""
      maskStyle={styles.mask}
      containerStyle={styles.containerStyle}
      handleClose={() => dispatch(setWpResultShow(false))}
    >
      <div className="wp_exchange_img">
        <img src={result?.resultCode === '1' ? SuccessImg : ErrImg} />
      </div>
      <div className="wp_result">{result?.resultCode === '1' ? '兑换成功' : '兑换失败'}</div>
      <div className="wp_result_desc">{resultObj[result?.resultCode]}</div>
      <div
        className="wp_btn"
        onClick={() => {
          dispatch(setWpResultShow(false));
        }}
      >
        知道了
      </div>
    </Dialog>
  );
});
